<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BWiQTG/tc-custom/9780718096427.jpg?1704761522364" alt="This image is the cover for the book Lead Like a Shepherd, Next Leadership Network"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lead Like a Shepherd, Next Leadership Network
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Pastor, author, and leadership consultant unpacks instruction for church leaders found in 1 Peter 5:1-4 where they are exhorted to shepherd the flock among them.</b></p><p>Some instruction is timeless. Regardless of the age in which we live, certain instruction carries no expiration on its relevance. Pastor, author, and leadership consultant, Larry Osborne has discovered this to be the case with instruction on how to be a good leader. The best, most practical advice comes from the Bible, and in particular, 1 Peter 5:1-4. It's in this short passage where leaders are exhorted to <i>shepherd</i> the flock among them.</p><p>Unfortunately, most modern leaders have precious little experience tending sheep, and many of the implications that were well understood when Peter penned these words are lost on today's reader. Osborne finds the parallels to be numerous, well-worth reviewing and understanding anew.</p><p>A shepherd leads them to water even when they fear it. A shepherd never allows one sick lamb to destroy the flock. A shepherd lays down his life for his sheep . . .</p><p>When leaders truly understand Peter's words of exhortation to lead like a shepherd, then they will begin to see the path that leads them to <i>Leading Well</i>.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Larry Osborne
      </h2>
      
      <p class="authorDescription body article"><P>Larry Osborne is a teaching pastor at North Coast Church in northern San Diego County. North Coast is widely recognized as one of the most influential and innovative churches in America. Osborne speaks extensively on the subjects of leadership and spiritual formation. His books include <I>Sticky Teams</I>, <I>Sticky Church</I>, <I>10 Dumb Things Smart Christians Believe</I>, and <I>Spirituality for the Rest of Us</I>. He and his wife, Nancy, live in Oceanside, California.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2069b5d0